import React, { useMemo } from 'react';
import { connect } from 'umi';
import { isEqual } from 'lodash-es';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import useIntls from '@opm/hooks/useIntls';
import { TSecondOptionsItem, IMultipleCommonType } from '../../types';
import {
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
} from '../../connect/multiple';
import { CommonSelectButton } from '../../components/CommonSelectButton';
import { getCountryFlag } from '@/pages/home/_config/countries';
import './index.scss';

export type TRegionSelectType = {
  options: TSecondOptionsItem[];
  valueKeys: string;
  title: string;
  titleCn: string;
  leftText?: string;
  allText?: string;
  allTextCn?: string;
  hasSelectAllBtn?: boolean;
  matchButtonWidth?: boolean;
  itemRender?: (option: any) => React.ReactNode;
  hasGlobal?: boolean;
  maxDisplayCount?: number;
};

interface RegionMarketValue {
  type: 'market';
  regions: string[];
  markets: string[];
}

interface IRegionSelectInnerProps
  extends TRegionSelectType,
    Omit<IMultipleCommonType, 'value'> {
  filterValue: any;
  value?: RegionMarketValue | string[];
  onClose?: () => void;
}

export function RegionSelect({
  value,
  change,
  onClose,
  options = [],
  title,
  titleCn,
  itemRender,
  hasGlobal = true,
  maxDisplayCount,
}: IRegionSelectInnerProps) {
  const { isEn } = useIntls();
  const locale = isEn ? 'en-US' : 'zh-CN';

  // 处理 options，为 region 添加图标
  const processedOptions = useMemo(() => {
    return options.map((opt: any) => ({
      ...opt,
      children: opt.children.map((item: any) => {
        return {
          ...item,
          icon: getCountryFlag(item.code),
        };
      }),
    }));
  }, [options]);

  const buttonElement = (
    <CommonSelectButton
      value={value}
      options={options}
      title={title}
      titleCn={titleCn}
      itemRender={itemRender}
      supportFlat={true}
      maxDisplayCount={maxDisplayCount}
    />
  );

  const radioOptions = useMemo(() => {
    if (!hasGlobal) return undefined;
    return [
      {
        textCN: '全球',
        text: 'Global',
        value: 'global',
      },
    ];
  }, []);

  const regionTitleLocal = useMemo(
    () => ({
      'zh-CN': {
        regionTitle: '地区',
        marketTitle: titleCn || '地区',
      },
      'en-US': {
        regionTitle: 'Region',
        marketTitle: title || 'Region',
      },
    }),
    [title, titleCn],
  );

  return (
    <div className="dbom-region-select-wrapper">
      <NewRegionSelect
        value={value}
        options={processedOptions}
        locale={locale}
        button={buttonElement}
        radioOptions={radioOptions}
        language={regionTitleLocal}
        closeOnScroll={true}
        renderTag={itemRender}
        onChange={(selectValue: any) => {
          // 判断是否和原值相同，相同则不改变
          const isSame = isEqual(selectValue, value);
          if (!isSame) {
            change(selectValue);
          }
        }}
        onCloseReginSelect={() => {
          onClose?.();
        }}
      />
    </div>
  );
}

export default connect(
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
)(RegionSelect);
